/**
 * Company: AltSolution
 * Author: Ivan Horobets
 */

"use strict";
if($('.ship_pay').length) {

    //Toggle table only (mobile)
    if($(window).width() <= 767) {
        let $toggleWrap = $('.table_toggle_open');
        $toggleWrap.on('click', '.toggle .top', function () {
            $(this).toggleClass('open');
            $(this).siblings('.bottom').slideToggle(200);
        });
    }

    //Toggle tabs content (mobile)
    if($(window).width() <= 767) {
        let $sPTabs = $('.ship_pay_tabs'),
            $deliveryContent = $('#delivery-video, #delivery-content'),
            $payContent = $('#pay-video, #pay-content');

        $sPTabs.on('click', 'li:not(.active)', function () {
            $(this).parent().find('li').removeClass('active');
            $(this).addClass('active');

            //Show|hide content
            if($(this).data('type') === 'delivery') {
                $payContent.fadeOut(200, function () {
                    $deliveryContent.fadeIn(200);
                })
            } else {
                $deliveryContent.fadeOut(200, function () {
                    $payContent.fadeIn(200);
                })
            }
        });
    }

    //Anchor
    $('a[href^="#"].anchor').on('click',function (e) {
        e.preventDefault();
        let target = this.hash,
            $target = $(target);

        $('html, body').stop().animate({
            'scrollTop': $target.offset().top - 80
        }, 300, 'swing');
    });
}